module.exports = __webpack_public_path__ + "img/td.9a6e19b6.svg";